import { Input } from "@chakra-ui/react";

export default function GlassInput({ value, onChange, placeholder, ...rest }) {
  return (
    <Input
      color="text.onGlass"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      borderRadius="control"
      size="md"
      bg="glass.field"
      border="1px solid"
      borderColor="blackAlpha.200"
      _placeholder={{ color: "gray.500" }}
      _hover={{ borderColor: "blackAlpha.300" }}
      _focus={{
        bg: "rgba(255, 255, 255, 0.96)",
        borderColor: "brand.500",
        boxShadow: "focus",
      }}
      {...rest}
    />
  );
}
